import { useAuth } from '@/contexts/AuthContext';
import type { Plan } from '@/lib/supabase';

export interface PlanInfo {
  plan: Plan;
  isPremium: boolean;
  isFree: boolean;
  isAuthenticated: boolean;
  // Limits
  keywordLimit: number;      // max keywords shown (free=10, premium=100)
  scanLimit: number;         // max scans/day (free=3, premium=unlimited=-1)
  tldLimit: number;          // max TLDs per scan (free=20, premium=unlimited=-1)
}

const FREE_LIMITS = { keywordLimit: 10, scanLimit: 3, tldLimit: 20 };
const PREMIUM_LIMITS = { keywordLimit: 100, scanLimit: -1, tldLimit: -1 };

export function usePlan(): PlanInfo {
  const { plan, isAuthenticated } = useAuth();
  const isPremium = plan === 'premium';
  const limits = isPremium ? PREMIUM_LIMITS : FREE_LIMITS;
  return {
    plan,
    isPremium,
    isFree: !isPremium,
    isAuthenticated,
    ...limits,
  };
}
